import { NavLink, type NavLinkProps } from '@mantine/core';
import { type ReactNode, Suspense } from 'react';
import { useCurrentURL } from './useCurrentURL';

export interface ConditionalNavLinkProps extends NavLinkProps {
	href: string;
}

function ConditionalNavLinkContent(props: ConditionalNavLinkProps): ReactNode {
	const currentURL = useCurrentURL();
	let active = false;
	let href: string | undefined = props.href;

	// We're already here, no need to link to anything
	if (href === currentURL) {
		active = true;
		href = undefined;
	}

	return <NavLink {...props} active={active} />;
}

export function ConditionalNavLink(props: ConditionalNavLinkProps): ReactNode {
	// Wrap in Suspense due to use of useSearchParams
	// https://nextjs.org/docs/app/api-reference/functions/use-search-params
	return (
		<Suspense>
			<ConditionalNavLinkContent {...props} />
		</Suspense>
	);
}
